import { Box, Container, Link } from "@mui/material";
import Paper from "../../modules/components/Paper";
import React from "react";
import Typography from "../../modules/components/Typography";
import Button from "../../modules/components/Button";
import Reasons from "./Reasons";
import {useNavigate, useOutletContext} from "react-router-dom";
import Loading from "./Loading";

const Content = ({handleClick}) => (
  <Box sx={{ mt: 2, mb: 4 }}>
    <Paper
      background="light"
      sx={{ py: { xs: 4, md: 8 }, px: { xs: 3, md: 6 } }}
    >
      <Typography variant="h3" gutterBottom marked="center" align="center" pb={4}>
        Thank You
      </Typography>
      <Typography variant="body2" align="center">
        You have successfully upgraded to collector. Don't forget to <Link style={{cursor: 'pointer'}} onClick={() => handleClick("/update-profile")}>Update your Contact Info</Link> before you use phone notifications!
        <br/><br/>
        You can manage your subscription at any time in the <Link style={{cursor: 'pointer'}} onClick={() => handleClick("/upgrade")}>Manage Collector Status</Link> tab.
        <br/><br/>
        Collectors have access to:
      </Typography>
      <Reasons />
      <Box sx={{ m: 2 }}>
        <Button 
          variant="contained"
          fullWidth
          href="/dashboard"
        >
          Return to Your Subscriptions
        </Button>
      </Box>
    </Paper>
  </Box>
);

export default function ThankYou() {
  const [, refresh, setRefresh] = useOutletContext();
  const timerRef = React.useRef(null);

  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate("/dashboard" + path);
  }

  React.useEffect(() => {
    timerRef.current = setTimeout(() => {
      if (refresh === 0)
        setRefresh(prevRefresh => ++prevRefresh);
    }, 6000);
    return () => clearTimeout(timerRef.current);
  }, [refresh, setRefresh])

  return (
    <Container maxWidth="sm" sx={{ flexGrow: 1, p: 2 }}>
      {refresh === 0 ? <Loading /> : <Content handleClick={handleClick} />}
    </Container>
  );
}